<script lang="ts">
	import type { Post, Season } from '#lib/schema-extension.js';
	import { setAttr } from '@directus/visual-editing';
	import { PUBLIC_API_URL } from '$app/env/public';
	import { getId } from '#lib/directus/directus.js';
	import upperFirst from 'lodash/upperFirst';
	import dayjs from 'dayjs';
	import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
	import { faCalendarAlt, faSnowflake } from '@fortawesome/free-solid-svg-icons';

	let { post }: { post: Post } = $props();

	let postUrl = $derived(() => {
		if (post.slug?.startsWith('wildcats')) {
			return '/wildcats/blog/' + post.slug.substring(post.slug.lastIndexOf('/') + 1);
		} else {
			return '/blog/' + post.slug;
		}
	});
</script>

<div
	data-directus={setAttr({
		collection: 'posts',
		item: post.id!,
		mode: 'modal'
	})}
>
	<article class="bg-base-100 flex h-full min-w-0 flex-col overflow-hidden">
		{#if post.image}
			<a href={postUrl()} tabindex="-1" aria-hidden="true">
				<img
					class="aspect-video w-full object-cover"
					src={`${PUBLIC_API_URL}/assets/${getId(post.image)}?key=thumbnail`}
					alt=""
					loading="lazy"
				/>
			</a>
		{/if}
		<div class="flex grow flex-col gap-3 p-4 sm:p-5">
			<h2
				class="border-0 text-xl font-bold"
				data-directus={setAttr({
					collection: 'posts',
					item: post.id!,
					fields: 'title',
					mode: 'popover'
				})}
			>
				<a href={postUrl()} class="decoration-accent underline-offset-4 hover:underline"
					>{post.title && upperFirst(post.title)}</a
				>
			</h2>
			{#if post.description}
				<p
					class="leading-relaxed"
					data-directus={setAttr({
						collection: 'posts',
						item: post.id!,
						fields: 'description',
						mode: 'popover'
					})}
				>
					{upperFirst(post.description)}
				</p>
			{/if}
			<div class="mt-auto flex flex-wrap items-center justify-between gap-3 pt-3">
				<div class="flex flex-wrap gap-2 text-sm">
					<time
						class="bg-base-200 inline-flex items-center gap-2 rounded px-2 py-1"
						datetime={post.date_created ?? undefined}
					>
						<FontAwesomeIcon icon={faCalendarAlt} />{dayjs(post.date_created).format('DD.MM.YYYY')}
					</time>
					{#if post.season}
						<span class="bg-base-200 inline-flex items-center gap-2 rounded px-2 py-1"
							><FontAwesomeIcon icon={faSnowflake} />{(post.season as Season).title}</span
						>
					{/if}
				</div>
				<a class="btn btn-accent btn-outline min-h-11" href={postUrl()}
					>Weiterlesen<span class="sr-only">: {post.title}</span></a
				>
			</div>
		</div>
	</article>
</div>
